// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { type VMessageTemplateContext } from '../../index.ts';

import { AssertError } from '@atlassian/vindicated';
export function assert(value: any): VMessageTemplateContext {
    const result = validate(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new AssertError('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data as VMessageTemplateContext;
}
export { assert as assertMessageTemplateContext };


export function is(value: any): value is VMessageTemplateContext {
	const result = validate(value);
    return result.success;
}
export { is as isMessageTemplateContext };


import { type ValidationResult } from '@atlassian/vindicated';
export function validate(value: any): ValidationResult<VMessageTemplateContext> {
    const errors = [];
    const originalData = value;
    
	if (typeof value !== 'object' || value === null || Array.isArray(value)) {
        errors.push({ path: 'value', expected: 'MessageTemplateContext', value: value });
    } else {
			if (!('product' in value)) {
				errors.push({ path: 'value["product"]', expected: '"jira" | "confluence"', value: undefined });
			} else {
				
    {
        let value__product___valid = false;
        
        if (!value__product___valid) {
            const value__product___errors_0 = [];
            if (value["product"] !== "jira") value__product___errors_0.push({ path: 'value["product"]', expected: "jira", value: value["product"] });
            if (value__product___errors_0.length === 0) {
                value__product___valid = true;
            }
        }

        if (!value__product___valid) {
            const value__product___errors_1 = [];
            if (value["product"] !== "confluence") value__product___errors_1.push({ path: 'value["product"]', expected: "confluence", value: value["product"] });
            if (value__product___errors_1.length === 0) {
                value__product___valid = true;
            }
        }
        if (!value__product___valid) {
            errors.push({ path: 'value["product"]', expected: '"jira" | "confluence"', value: value["product"] });
        }
    }
			}
			if (!('cloudId' in value)) {
				errors.push({ path: 'value["cloudId"]', expected: 'string', value: undefined });
			} else {
				if (typeof value["cloudId"] !== 'string') errors.push({ path: 'value["cloudId"]', expected: 'string', value: value["cloudId"] });
			}
			if (!('twcEntitlementId' in value)) {
				errors.push({ path: 'value["twcEntitlementId"]', expected: 'string', value: undefined });
			} else {
				if (typeof value["twcEntitlementId"] !== 'string') errors.push({ path: 'value["twcEntitlementId"]', expected: 'string', value: value["twcEntitlementId"] });
			}
    }
    if (errors.length === 0) return { success: true, data: value };
    return { success: false, data: originalData, errors: errors };
}
export { validate as validateMessageTemplateContext };
